import { lazy } from '../../shared/deployment';

export const HeadTagsInit = lazy(() => import('./ui/HeadTagsInit'));
export { SET_HEAD_TAGS } from './model/slice';
export { MODULE_NAME } from './model/constants';
export { reducer } from './model/slice';
